import { InputAdornment, MenuItem, TextField } from "@mui/material";
import { ChangeEvent, FunctionComponent } from "react";

import { faCheck } from "@fortawesome/pro-regular-svg-icons";

import { Role } from "@/enum";

import { SvgIcon } from "@/components/Icon/SvgIcon";

import { ReactComponent as Mail } from "@assets/icons/mail.svg?react";

import { Icon } from "@/components";

import { UserRole } from "../../UserRoles/schema/roles";

interface InviteUserItemProps {
	email: string;
	role: string;
	roles: UserRole[];
	onEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onRoleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const InviteUserItem: FunctionComponent<InviteUserItemProps> = ({
	email,
	role,
	roles,
	onEmailChange,
	onRoleChange,
}) => {
	return (
		<div className="flex flex-row w-full gap-2">
			<TextField
				InputProps={{
					startAdornment: (
						<InputAdornment
							position="start"
							sx={{
								"&:not(.MuiInputAdornment-hiddenLabel)": {
									marginTop: "0px !important",
								},
							}}
						>
							<div className="mr-2 flex items-center">
								<SvgIcon className="w-[20px] h-[20px] text-gray-500" svgIcon={Mail} />
							</div>{" "}
						</InputAdornment>
					),
				}}
				className="w-full"
				inputProps={{
					style: {
						display: "flex",
						alignItems: "center",
						padding: "12px 0px",
					},
				}}
				placeholder="you@example.com"
				sx={{
					"& .MuiInputBase-root": {
						marginBottom: "8px",
						borderRadius: "12px",
						fontSize: "14px",
					},
				}}
				value={email}
				onChange={onEmailChange}
			/>
			<TextField
				select
				SelectProps={{
					renderValue: (selected) => <>{selected}</>,
					MenuProps: {
						PaperProps: {
							sx: {
								padding: "8px",
								width: "140px",
								marginTop: "4px",
								borderRadius: "12px",
								"& .MuiList-root": {
									margin: "0px",
									padding: "0px",
									gap: "8px",
									display: "flex",
									flexDirection: "column",
								},
								"& .MuiMenuItem-root": {
									display: "flex",
									alignItems: "center",
									justifyContent: "space-between",
									fontSize: "14px",
									margin: "0px",
									padding: "0px",
									backgroundColor: "transparent !important",
									"&.Mui-selected": {
										color: "#B8431A",
									},
									"&:hover": {
										backgroundColor: "transparent !important",
									},
								},
							},
						},
					},
				}}
				inputProps={{
					style: {
						display: "flex",
						alignItems: "center",
						fontSize: "14px",
					},
				}}
				sx={{
					"min-width": "140px",
					"& .MuiSelect-select": {
						alignSelf: "flex-end",
						padding: "10px",
						fontSize: "14px",
					},
					"& .MuiInputBase-root": {
						marginBottom: "0px",
						borderRadius: "12px",
						fontSize: "14px",
					},
					"& .MuiSelect-icon": {
						color: "#11110F",
					},
				}}
				value={role ?? Role.USER}
				onChange={onRoleChange}
			>
				{roles.map((item) => (
					<MenuItem key={item.id} value={item.name}>
						{item.name}
						{role === item.name && <Icon className="ml-2 w-5 h-5" icon={faCheck} />}
					</MenuItem>
				))}
			</TextField>
		</div>
	);
};
